import { Box, Flex } from "@chakra-ui/react";

import { SagaWorkSteps } from "./chat/SagaWorkSteps";
import { SagaWorkChat } from "./chat/SagaWorkChat";

export function SagaWork() {
  return (
    <Box
      w="100%"
      bg="blue.500"
      px={{ base: 4, md: 10 }}
      py={{ base: 12, md: 20 }}
    >
      <Flex
        direction={{ base: "column", lg: "row-reverse" }}
        gap={{ base: 10, lg: 3 }}
        maxW="95%"
        mx="auto"
        align="stretch"
      >
        {/* Chat */}
        <Box
          flex={1}
          display="flex"
          justifyContent="center"
          alignItems="stretch"
          minH="100%"
        >
          <SagaWorkChat />
        </Box>

        {/* Steps */}
        {/* <Box flex={1} display="flex" justifyContent={"center"}>
          <SagaWorkSteps />
        </Box> */}
      </Flex>
    </Box>
  );
}
